import {Component, Inject, OnInit} from '@angular/core';
import {SafeHtml} from '@angular/platform-browser';
import {finalize, take} from 'rxjs/operators';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ReportingService} from '../../../../other/services/reporting.service';

@Component({
  selector: 'app-generic-dialog-report',
  templateUrl: './generic-report-dialog.component.html',
  styleUrls: ['../../../../../../styles/global/_dialog-styles.scss']
})
export class GenericReportDialogComponent implements OnInit {
  html: SafeHtml;
  isBusyCounter = 0;
  isHtmlValid = true;
  heading: string;
  reportURI: string;
  reportFileName = true;
  reportParameters: string;
  downloadPdfReportFileName: string;

  constructor(
    public dialogRef: MatDialogRef<GenericReportDialogComponent>,
    private reportingService: ReportingService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.heading = data?.heading;
    this.reportURI = data?.reportURI;
    this.reportParameters = data?.reportParameters;
    this.reportFileName = data?.showDownloadPdfReportButton ?? true;
    this.downloadPdfReportFileName = data?.downloadPdfReportFileName;
  }

  ngOnInit(): void {
    this.getHTMLReport();
  }

  onClickGenerate(): void {
    this.getPDFReport();
  }

  onClickCancel(): void {
    this.dialogRef.close(this.data?.note);
  }

  private getHTMLReport(): void {
    if (!this.reportURI) {
      return;
    }
    this.isBusyCounter++;
    this.reportingService.generateHTMLReport(this.reportURI, this.reportParameters)
      .pipe(
        take(1),
        finalize(() => this.isBusyCounter--)
      )
      .subscribe({
        next: (html: SafeHtml) => {
          this.html = html;
        },
        error: (error) => {
          console.error('Error fetching report:', error);
          this.isHtmlValid = false;
        }
      });
  }

  private getPDFReport(): void {
    if (!this.reportURI) {
      return;
    }
    this.reportingService.downloadPDFReport(this.reportURI, this.reportParameters, this.downloadPdfReportFileName);
  }

}
